<template>
  <div
    class="newsroom-item grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 lg:gap-100 md:gap-15"
  >
    <div class="md:col-span-1 lg:col-span-3 mb-60 md:mb-0">
      <h2 class="is-2">{{ title }}</h2>
      <div v-if="created" class="text-sm mb-40 mt-4 font-light">
        {{ createdFormatted }}
      </div>
      <div class="content">
        <p v-html="lead" />
      </div>
      <DrupalLink
        v-if="to"
        :to="to"
        class="link icon-link mt-25 icon arrow-icon-link"
      >
        <span>{{ $texts('article.read', 'Read') }}</span>
      </DrupalLink>
    </div>
    <div class="md:col-span-1 lg:col-span-2 aspect-[4/3] bg-gray">
      <MediaImage v-if="image" v-bind="image" style-name="column_third" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { NodeBlogArticleTeaserFragment } from '#build/graphql-operations'

const props = defineProps<{
  title?: string
  uuid?: string
  lead?: string
  url?: NodeBlogArticleTeaserFragment['url']
  image?: NodeBlogArticleTeaserFragment['image']
  tags?: NodeBlogArticleTeaserFragment['tags']
  createdField?: NodeBlogArticleTeaserFragment['createdField']
  created?: NodeBlogArticleTeaserFragment['created']
}>()

const createdFormatted = computed(() =>
  new Date(props.created!).toLocaleDateString('de-CH'),
)

const to = computed(() => props.url?.path)
</script>
